import './src/vaadin-notification.js';
export * from './src/vaadin-notification.js';
